export default __webpack_public_path__ + "static/media/icon-test-taker-todo.1e0c12b0.svg";